import { QueryFilter } from '@recast-navigation/core';

/**
 * Helper function to create a `QueryFilter` with optional flags.
 * @param includeFlags
 * @param excludeFlags
 * @returns
 */
export const makeQueryFilter = (includeFlags?: number, excludeFlags?: number) => {
  const filter = new QueryFilter();
  if (includeFlags !== undefined) {
    filter.includeFlags = includeFlags;
  }
  if (excludeFlags !== undefined) {
    filter.excludeFlags = excludeFlags;
  }

  return filter;
};
